module.exports = __webpack_public_path__ + "img/h.75fc5a43.png";